import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import Accordion from './Accordion';
import Box from '@material-ui/core/Box';
import { useSelector, useDispatch } from 'react-redux';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import WatchList from './WatchList';
import { NoData } from '../Alerts';
import { useStyles } from './styles';
import { Drawer } from '../../../common';
import {
	setIsWatchListOpen,
	setIsNotificationOpen,
	getWatchList,
} from '../../../redux/actions/createRuleActions';
import { UserPortalContext } from '../../../context/appcontext';

const Notifications = ({ onClose }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { data: notifications, isNotificationOpen } = useSelector(
		(state) => state.createRuleReducer
	);
	const showNoDataMessage = notifications?.length === 0;
	const portalUserContext = useContext(UserPortalContext);

	/**
	 * Close Notification
	 * Show WatchList(Rules) Component
	 */
	const handleSettingClick = () => {
		dispatch(getWatchList({ portalUserContext }));
		dispatch(setIsNotificationOpen(false));
		dispatch(setIsWatchListOpen(true));
	};

	const onNotificationClose = () => onClose();

	return (
		<Fragment>
			<Drawer
				open={isNotificationOpen}
				width={360}
				onClose={onNotificationClose}>
				<Box className={classes.container}>
					{/* Header */}
					<Box className={classes.header}>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<ArrowBackIosNewIcon
								className={classes.backBtn}
								onClick={onNotificationClose}
							/>
							<Box className={classes.headerText}>Notifications</Box>
						</Box>
						<SettingsIcon
							className={classes.settingIcon}
							onClick={handleSettingClick}
						/>
					</Box>
					{/* Content */}
					<Box className={classes.content}>
						{/* No Data */}
						{showNoDataMessage ? (
							<NoData
								title={'No notifications yet'}
								content={'When you have a notification they will show up here'}
							/>
						) : null}
						<Box>
							{Array.isArray(notifications) &&
								notifications?.map((item, i) => (
									<Accordion
										key={i}
										title={item?.name}
										description={item.message}
										createdDate={item.createdTimeStamp}
										hasSubAlerts={item.hasSubAlerts}
										parentId={item.id}
									/>
								))}
						</Box>
					</Box>
				</Box>
			</Drawer>
			{/* WatchList/Rules w/ Drawer */}
			<WatchList
				onClose={() => {
					dispatch(setIsNotificationOpen(true));
					dispatch(setIsWatchListOpen(false));
				}}
			/>
		</Fragment>
	);
};

Notifications.propTypes = {
	onClose: PropTypes.func,
};

export default Notifications;
